import { useEffect, useState, useLayoutEffect } from "react";
// import { useMoralis } from "react-moralis";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Account from "components/Account/Account";
import Dashboard from "components/Dashboard";
import Debugger from "components/Debugger";
import { Layout, Row, Col } from "antd";
import H4GLogo from "./assets/h4g-logo-rect.png";
import Web3 from "web3";
// import MainTokenPrice from "components/MainTokenPrice";
import rfcLogo from "./assets/rfc-logo.svg";

import "antd/dist/antd.css";
import "./style.css";
const { Header, Footer } = Layout;

const styles = {
  content: {
    fontFamily: "Montserrat Roboto, sans-serif",
    color: "#041836",
    marginTop: "90px",
    padding: "10px",
  },
  header: {
    position: "fixed",
    zIndex: 999,
    width: "100%",
    height: "auto",
    background: "#00002E",
    fontFamily: "Montserrat Roboto, sans-serif",
    borderBottom: "2px solid #0A0047",
    padding: "5px 30px",
  },
  headerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
  },
};
const App = () => {
  // const { isWeb3Enabled, enableWeb3, isAuthenticated, isWeb3EnableLoading } = useMoralis();

  const [width, setWidth] = useState(window.innerWidth);
  const breakPoint = 768;
  // const tokenAddress = process.env.REACT_APP_MAIN_TOKEN_ADDRESS;
  useLayoutEffect(() => {
    if(!window.web3Instance){
      //initiate web3 instance globally 
      const httpProvider = new Web3.providers.HttpProvider(process.env.REACT_APP_WEB3_HTTP_PROVIDER);
      const web3 = new Web3(httpProvider);
      window.web3Instance = web3;
    }
  }, []);
  
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  },[]);

  // useEffect(() => {
  //   if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading) enableWeb3();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthenticated, isWeb3Enabled]);

  return (
    <Layout style={{ height: "100vh", overflow: "auto" }}>
      <Router>
        <Header style={styles.header}>
          <Row gutter={16} style={{ alignItems:'center'}}>
            <Col span={8}>
              <a href="https://www.hodl4gold.com" target="_blank" rel="noreferrer">
                <Logo/>
              </a>
            </Col>
            <Col span={16}>
              {width > breakPoint? (
                <Row>
                  <Col span={24} className="account-container">
                    <Account /> 
                    {/* <MainTokenPrice tokenAddress={tokenAddress}/> */}
                  </Col>
                </Row>
                ) : (
                <Row>
                  <Col span={24} style={{display:'flex', justifyContent:'end' }}>
                    <Account /> 
                  </Col>
                </Row>  
                )}
              
            </Col>
          </Row>
        </Header>

        <div style={styles.content} className="inner-data-container">
          <Switch>
            <Route exact path="/dashboard">
              <Dashboard/>
            </Route>
            <Route exact path="/debugger">
              <Debugger/>
            </Route>
            <Route path="/">
              <Redirect to="/dashboard" />
            </Route>
            <Route path="/nonauthenticated">
              <>Please login using the "Authenticate" button</>
            </Route>
          </Switch>
        </div>
      </Router>
      <Footer style={{ textAlign: "center", background:"#030017", width: "100%" }}>
      <a target="_blank" href={"https://www.rugfreecoins.com/"} rel="noreferrer">
          <Row align="center">
            <Col style={{ marginTop: '8px', color: 'white', marginRight: '10px' }}>Developed By  </Col>
            <Col><img alt="rugfreecoins" src={rfcLogo} style={{ height: '35px', width: '35px' }} /></Col>
            <Col style={{ marginTop: '8px', color: 'white', marginLeft: '10px' }}>RugFreeCoins</Col>
          </Row>
        </a>
      </Footer>
    </Layout>
  );
};

function Logo() {
  return (
    <div>
      <img alt="hold4gold" className="h4ld-main-logo" src={H4GLogo} style={{  width: '200px', margin: '5px 0' }}/>
    </div>
  );  
}
  


export default App;
